/**
 * What the books took from the log.
 *
 * The log keeps every event, and the server sends a phone the ones its books refused like any
 * other: a sale voided a second time, a handover of a drawer already handed over, a payment of a
 * bill already paid. They change nothing, but a screen that counts events counted them: «Control»
 * read a sale voided twice as two voids, and a refused handover moved the drawer to somebody else,
 * so the next shortage was theirs (2026-10-13). Read inside a live query, so what it shows follows
 * a replay that changes its mind.
 */

import { db, type LocalEvent } from '../db/dexie.js';

/** The ids of the events this device's books refused (`SinEfectoRow`). */
export async function leerSinEfecto(): Promise<ReadonlySet<string>> {
  return new Set(await db.sinEfecto.toCollection().primaryKeys());
}

type Registrado = Pick<LocalEvent, 'id' | 'estado'>;

/**
 * Whether the books took it: not refused here as it was recorded (`rechazado`), nor by the books
 * as the log was applied (`sinEfecto`).
 */
export const tuvoEfecto = (e: Registrado, sinEfecto: ReadonlySet<string>): boolean => e.estado !== 'rechazado' && !sinEfecto.has(e.id);
